import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const RecaptchaProtectionMessage = () => {
    return (
        <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <LockOutlinedIcon />
                </Grid>
                <Grid item xs>
                    <Typography>
                        <small>This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</small>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default RecaptchaProtectionMessage;